import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { TextLoader } from '~/components'

import {
	NewComment,
	SingleComment as Comment
} from './components'

class Comments extends React.Component {

    static propTypes = {
		comments: PropTypes.array,
		fetching: PropTypes.bool,
		articleID: PropTypes.number.isRequired,
		session: PropTypes.object
	};

    render() {
		let { isSession } = this.props;
		return (
			<div className="comments bg-off-white p20 mtop50 mright-20-xs mleft-20-xs" id="comments">
				{ isSession
					? <NewComment articleID={this.props.articleID} />
					: <p className="text-center mtop30 mbot30"><Link to="/login/">Create an account or login to comment</Link></p>
				}
				{( this.props.fetching
            		? <TextLoader />
					: this.props.comments && this.props.comments.length
						? <div className="comments-list">
							{this.props.comments.map( comment => {
								return <div className="comment-wrapper" key={"parent-comment-"+comment.ID}>
									<Comment {...comment} articleID={this.props.articleID} replyID={comment.ID} isSession={isSession} />
									{comment.children.length > 0 && comment.children.map( child => {
										return <Comment {...child} articleID={this.props.articleID} replyID={comment.ID} key={'child-comment-'+child.ID} isSession={isSession} />
									})}
								</div>
							})}
						</div>
						: isSession && <p className="text-center mtop50 mbot30">No comments yet. Be the first!</p>
				)}
			</div>
		)
	}
}

const mapStateToProps = state => ({
    isSession: 'ID' in state.session.user,
});

export default connect(
    mapStateToProps,
)(Comments);




// WEBPACK FOOTER //
// ./src/js/views/Article/components/Comments/index.js